import React, { FunctionComponent } from 'react';

import useTheme from '@gojob/ui-bits/styles/useTheme';
import Typography from '@gojob/ui-bits/Typography';

export type SubtitleProps = {
  children: React.ReactNode;
};

const useStyles = () => {
  const { breakpoint } = useTheme();
  return {
    root: {
      [breakpoint.up('md')]: {
        minHeight: '33%',
      },
    },
  };
};

const Subtitle: FunctionComponent<SubtitleProps> = (props) => {
  const { children } = props;
  const classes = useStyles();

  return (
    <Typography css={classes.root} color="white">
      {children}
    </Typography>
  );
};

export default Subtitle;
